module.exports = __webpack_public_path__ + "img/qrcode.d115910e.svg";